/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * BarGraphVerticalIcon
 */
export default class BarGraphVerticalIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M3 2a1 1 0 011 1v16.5h17a1 1 0 010 2H3a1 1 0 01-1-1V3a1 1 0 011-1zm4 7.5a1 1 0 01.993.883L8 10.5v7a1 1 0 01-1.993.117L6 17.5v-7a1 1 0 011-1zm4-4a1 1 0 01.993.883L12 6.5v11a1 1 0 01-1.993.117L10 17.5v-11a1 1 0 011-1zm4 2a1 1 0 01.993.883L16 8.5v9a1 1 0 01-1.993.117L14 17.5v-9a1 1 0 011-1zm4-5a1 1 0 01.993.883L20 3.5v14a1 1 0 01-1.993.117L18 17.5v-14a1 1 0 011-1z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

